import { openDialog } from "../../app-dialog/utils/core/dialogManager.js";
import { hasPermission, getUserId, getTeamId } from "../../../../app/auth.js";
import { showContextMenu } from "../../../../app/utils/contextMenu.js";
import { changeFactoring } from "../tableManager/entryManager.js";

export function buildContextMenu(permissions, dialogNames = {}, templateTransform = null) {
    return (event, component) => {
        const selectedRows = component.getTable().getSelectedRows();
        const isMultiSelect = selectedRows.length > 1;
        const data = selectedRows.length === 1 ? selectedRows[0].getData() : component.getData();
        const selectedData = isMultiSelect ? selectedRows.map(row => row.getData()) : [data];

        const canAct = (row, permission, ownPermission, teamPermission) =>
            hasPermission(permission)
            || (ownPermission && row.userId == getUserId() && hasPermission(ownPermission))
            || (teamPermission && row.teamId == getTeamId() && hasPermission(teamPermission));

        const items = [];

        items.push({ label: '<i class="fa-solid fa-file-arrow-down"></i> Exportieren', action: () => openDialog("export")})

        if (permissions.update && !isMultiSelect && !data.isFactored) {
            if (canAct(data, permissions.update, permissions.ownUpdate, permissions.teamUpdate)) {
                items.push({ label: '<i class="fa-solid fa-pen-to-square"></i> Bearbeiten', action: () => openDialog(dialogNames.edit ?? "edit", data) });
            }
        }

        if (permissions.create && hasPermission(permissions.create) && !isMultiSelect) {
            items.push({ label: '<i class="fa-solid fa-copy"></i> Als Vorlage verwenden', action: () => openDialog(dialogNames.create ?? "create", templateTransform ? templateTransform(data) : data) });
        }

        if (items.length > 1) items.splice(1, 0, { separator: true });

        if (permissions.factoring && hasPermission(permissions.factoring)) {
            if (items.length > 0) items.push({ separator: true });
            const factoringTarget = isMultiSelect ? selectedData.map(row => row.id) : data.id;
            if (isMultiSelect || !data.isFactored) {
                items.push({ label: '<i class="fa-solid fa-file-invoice-dollar"></i> Fakturieren', action: () => changeFactoring(factoringTarget, true) });
            }
            if (isMultiSelect || data.isFactored) {
                items.push({ label: '<i class="fa-solid fa-file-invoice"></i> Fakturierung entfernen', cssClass: 'danger', action: () => changeFactoring(factoringTarget, false) });
            }
        }

        if (permissions.delete) {
            const canDelete = selectedData.every(row => canAct(row, permissions.delete, permissions.ownDelete, permissions.teamDelete));
            if (canDelete) {
                if (items.length > 0) items.push({ separator: true });
                const deleteTarget = isMultiSelect ? selectedData : data;
                items.push({ label: '<i class="fa-solid fa-trash"></i> Löschen', cssClass: 'danger', action: () => openDialog(dialogNames.delete ?? "delete", deleteTarget) });
            }
        }

        if (items.length) showContextMenu(event, items);
        return false;
    };
}